import { language, languageConfiguration } from './lang';

export const languageDefinition = {
  id: 'parca',
  extensions: ['.parca'],
  aliases: ['parca'],
  mimetypes: [],
  def: {
    language,
    languageConfiguration,
  },
};
